/**
 * Check if the url provided is a valid Youtube urls for video embedding
 *
 * @param {string} url
 * @returns {boolean}
 */
const isValidYoutubeLink = url => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
  return youtubeRegex.test(url);
};

export default isValidYoutubeLink;
